import { Component } from '@angular/core';
import { SurveyModel, SurveyService } from '../../survey.Service';
import { ActivatedRoute, Router } from '@angular/router';
import { InterviewModel, InterviewService } from '../../question.service';
import { plainToClass } from 'class-transformer';
import { Subscription } from 'rxjs';
import { MissionService } from '../../MissionService';
import { OnDestroy } from '@angular/core';

@Component({
  selector: 'app-export-setup',
  templateUrl: './export-setup.component.html',
  styleUrl: './export-setup.component.css'
})
export class ExportSetupComponent implements OnDestroy {
  survey: SurveyModel;
  interview: InterviewModel;
  modelChecked: boolean = false;
  id: number;
  subscription: Subscription;

  constructor(
    private surveyService: SurveyService,
    private interviewService: InterviewService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private missionService: MissionService
) {
    this.id = Number(this.actRoute.snapshot.params.id);
    this.subscription = this.missionService.missionAnnounced$.subscribe(
      mission => {
        if (mission?.data?.action == "back") {
          this.router.navigate(['/surveyquestioneditor/' + this.id + '/survey']);
        }
      });
    this.surveyService.getSurveyDetail(this.id, false).subscribe(
      result => {
        this.survey = result;
        this.interviewService.getInterview(this.survey.ScriptID).subscribe(result => {
          if (result === null) {
            this.survey.QuestionCount = 0;
            this.interview = new InterviewModel();
            this.modelChecked = true;
          }
          else {
            this.interview = plainToClass(InterviewModel, result);
            this.interview.checkModel();
           // this.questionTexts = this.interview.textQuestions();
            this.modelChecked = true;
          }
        });

      }
    )
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }
}
